import { render } from "./CompositionItem.vue?vue&type=template&id=4ba1f89d"
import script from "./CompositionItem.vue?vue&type=script&lang=js"
export * from "./CompositionItem.vue?vue&type=script&lang=js"
script.render = render

export default script